// NGRX
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

// -------------------------------
//  Client State
// -------------------------------
export interface ClientState extends EntityState<any> {
  common?: any;
  clientLookup: Array<any>;
  clientLookupByUser: Array<any>;
  locatinLookupByUser: Array<any>;
  locationLookup: any;
  locationListLookup?: Array<any>;
  clientById?: any;
  clientAllList: Array<any>;
  locationAllList: Array<any>;
  areaAllList: Array<any>;
  clientLocationList: Array<any>;
  areaListByClientAndLocation: Array<any>;
  clientAllLookupList: Array<any>;
}

// -------------------------------
//  Client Adapter
// -------------------------------
export const ClientAdapter: EntityAdapter<any> = createEntityAdapter<any>({
});

// -------------------------------
//  Client Initial State
// -------------------------------
export const initialState: ClientState = ClientAdapter.getInitialState(
  {
    common: null,
    clientLookup: [],
    locationLookup: {},
    locationListLookup: [],
    clientById: null,
    clientAllList: [],
    locationAllList: [],
    areaAllList: [],
    clientLocationList: [],
    areaListByClientAndLocation: [],
    clientLookupByUser: [],
    locatinLookupByUser: [],
    clientAllLookupList: [],
  },
);
